import { render, staticRenderFns } from "./StaffPresence.vue?vue&type=template&id=4fbe304e&scoped=true&"
import script from "./StaffPresence.vue?vue&type=script&lang=ts&"
export * from "./StaffPresence.vue?vue&type=script&lang=ts&"
import style0 from "./StaffPresence.vue?vue&type=style&index=0&id=4fbe304e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbe304e",
  null
  
)

export default component.exports